<template>
<div class="page page_publishDZ">
    <!-- banner -->
    <div class="top_wrap">
        <img :src="publicPath+'statics/images/dingzhi/banner_form.png'" alt="" class="banner">
    </div>
    <!-- 发布信息 -->
    <div class="xinxi">
		<!-- 定制配置信息 -->
        <div class="item" v-for="(item,index) in configArr" :key="index">
            <div class="item_l">
                <span class="tag_required">*</span>
                <span class="">{{ item.title }}</span>
            </div>
            <div class="item_r">
				<!-- {{'请填写'+ item}} -->
                <van-field v-model="item.value" :placeholder="'请填写'+ item.title " :disabled="!canEdit"/>
            </div>
        </div>
        <!-- 上传图片 -->
        <!-- <div class="uploadTu">
            <div class="title">上传图片</div>
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div> -->
    </div>
    <!-- 发布 -->
    <div class="actions" @click="dingzhiFun" v-if="canEdit">
        <div class="bottom_action">提交</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
            imglist: [], // 上传的图片
			configArr: null,
			title: null,
            trade_uuid: this.$route.query.trade_uuid, // 先写死，试一下接口
            touuid: this.$route.query.user_uuid,
            canEdit: false
        };
    },
    created: function () {
        if (this.$route.query.user_uuid == null || this.$route.query.user_uuid == undefined) {
            this.touuid = this.$route.query.touuid
        }
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '定制单'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getMadeInfo()
                    this.getData()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getMadeInfo()
            this.getData()
            
		}
		
		// this.configItem()
    },
    methods: {
		// 定制配置信息
        getMadeInfo(){
			var params = {
                token: this.token,
				trade_uuid: this.trade_uuid
			}
			this.$api.dingzhi.madeInfo(params).then(res=>{
				if(res.code == 200){
					var config = res.result.config
                    console.log(config)
					var arr = JSON.parse(config)
                    this.updatedConfig(arr)
                    this.getDetail()
				}
			})
        },
        getData() {
            var that = this
            var params = {
                token: this.token,
            }
            this.$api.user.index(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    console.log('this.touuid:',this.touuid)
                    console.log('info:',res.result.info.uuid)
                    if (that.touuid == res.result.info.uuid) {
                        that.canEdit = true
                    }
                }
            })
        },
        getDetail() {
            var params = {
                token: this.token,
                uuid: this.touuid,
				trade_uuid: this.trade_uuid
			}
			this.$api.dingzhi.madeDetailInfo(params).then(res=>{
				if(res.code == 200){
					var config = res.result.content
					this.updatedDetail(config)
				}
			})
        },
        // 重组配置项
		updatedConfig(arr) {
			var newArr = []
			for(var i = 0 ; i < arr.length ; i++){
                var title = arr[i]
                if (title && title != undefined && title != "" && title != "null") {
                    var obj = {}
                    obj.title = title
                    obj.value = null
                    newArr.push(obj)
                }
			}
			this.configArr = newArr
			console.log('this',this)
		},
		// 重组配置项
		updatedDetail(config) {
            var newArr = []
            var content = JSON.parse(config) 
            console.log('content:',content)
            console.log(Object.keys(content))
            var keys = Object.keys(content)
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                var obj = {}
				obj.title = key
                obj.value = content[key]
                console.log(obj)
				newArr.push(obj)                
            }
            // Object.keys(content).forEach(function(key){
            //     console.log(key,obj[key]);
            //     var obj = {}
			// 	obj.title = key
			// 	obj.value = obj[key]
			// 	newArr.push(obj)
            // });
			this.configArr = newArr
			console.log('this',this)
		},
        // 上传图片
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        },
		// 定制匠人
		dingzhiFun(){
			console.log('configArr',this.configArr)
			var obj = {}
			for(var i = 0; i < this.configArr.length ; i++){
				var item = this.configArr[i]
				if(!item.value){
					this.$toast('请填写'+item.title)
					return
				}else{
                    obj[item.title] = item.value
				}
			}
			var params = {
				token: this.token,
				trade_uuid: this.trade_uuid,
				content: obj
			}
			this.$api.dingzhi.submitMadeInfo(params).then(res=>{
				if(res.code == 200){
					this.$toast(res.message)
                    if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                        //返回上级页面
                        var params = {'data':{}}
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
